import { unitSearchPanelCtrl } from './unit.search.panel.controller';
import template from './unit.search.panel.html';

export const unitSearchPanel: angular.IDirectiveFactory = () => ({
  bindToController: true,
  controller: unitSearchPanelCtrl,
  controllerAs: 'vm',
  template,
  restrict: 'A',
  scope: {
    sectionId: '@',
    houseId: '@',
    defaultCurrency: '@',
    verticalLayout: '=?',
  },
});
